'use strict';
(() => {
 const locale=(document.documentElement.lang||'en').toLowerCase().split('-')[0];
 const labels={fr:['Position {n} sur {total}','les bijoux'],en:['Position {n} of {total}','jewellery'],de:['Position {n} von {total}','Schmuck'],es:['Posición {n} de {total}','joyas'],fi:['Kohta {n} / {total}','korut'],hu:['{n}. elem / {total}','ékszerek'],it:['Posizione {n} di {total}','gioielli'],nl:['Positie {n} van {total}','sieraden'],pl:['Pozycja {n} z {total}','biżuteria'],sv:['Position {n} av {total}','smycken']};
 const [positionLabel,fallbackLabel]=labels[locale]||labels.en;
 const reduced=()=>window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
 function init(carousel){
  const track=carousel.querySelector('.site-product-track');
  const slides=[...track.children];
  const dots=carousel.querySelector('.site-carousel-dots');
  let positions=[];
  function sync(){
   const max=Math.max(0,track.scrollWidth-track.clientWidth);
   positions=[...new Set(slides.map(s=>Math.min(max,s.offsetLeft-slides[0].offsetLeft)))];
   if(dots.childElementCount!==positions.length){
    dots.replaceChildren(...positions.map((_,i)=>{const button=document.createElement('button');button.type='button';button.className='site-carousel-dot';button.dataset.position=i;button.setAttribute('aria-label',positionLabel.replace('{n}',i+1).replace('{total}',positions.length)+' : '+(carousel.dataset.carouselLabel||fallbackLabel));return button;}));
   }
   let current=0;positions.forEach((p,i)=>{if(Math.abs(p-track.scrollLeft)<Math.abs(positions[current]-track.scrollLeft))current=i;});
   [...dots.children].forEach((d,i)=>d.setAttribute('aria-current',String(i===current)));
   carousel.querySelector('[data-carousel-step="-1"]').disabled=track.scrollLeft<=2;
   carousel.querySelector('[data-carousel-step="1"]').disabled=track.scrollLeft>=max-2;
  }
  carousel.addEventListener('click',event=>{
   const dot=event.target.closest('[data-position]');
   const arrow=event.target.closest('[data-carousel-step]');
   if(!dot&&!arrow)return;
   const current=[...dots.children].findIndex(d=>d.getAttribute('aria-current')==='true');
   const index=dot?Number(dot.dataset.position):Math.max(0,Math.min(positions.length-1,current+Number(arrow.dataset.carouselStep)));
   track.scrollTo({left:positions[index],behavior:reduced()?'instant':'smooth'});
  });
  track.addEventListener('scroll',sync,{passive:true});
  track.addEventListener('keydown',event=>{if(!['ArrowLeft','ArrowRight'].includes(event.key))return;event.preventDefault();carousel.querySelector(`[data-carousel-step="${event.key==='ArrowLeft'?-1:1}"]`).click();});
  window.addEventListener('resize',sync);
  if(window.ResizeObserver)new ResizeObserver(sync).observe(track);
  sync();
 }
 document.querySelectorAll('[data-product-carousel]').forEach(init);

 // Same persistent list as the store's favorites drawer.
 const readFavorites=()=>{try{return JSON.parse(localStorage.getItem('ear_config_favorites')||'{}');}catch{return {};}};
 const ids=button=>[button.dataset.articleFavourite,...(button.dataset.variantIds||'').split(',').filter(Boolean)];
 function syncFavorites(){const favorites=readFavorites();document.querySelectorAll('[data-article-favourite]').forEach(b=>b.setAttribute('aria-pressed',String(ids(b).some(id=>favorites[id]))));}
 document.addEventListener('click',event=>{
  const button=event.target.closest('[data-article-favourite]');if(!button)return;
  event.preventDefault();
  const favorites=readFavorites(),adding=!ids(button).some(id=>favorites[id]);
  if(adding){
   const card=button.closest('.product-card-wrapper'),link=card.querySelector('.card__heading a'),img=card.querySelector('.card-primary-image');
   favorites[button.dataset.articleFavourite]={color:'OR',size:'',title:link.textContent.trim(),url:link.href,img:img.src,price:Number(button.dataset.priceCents),variantId:button.dataset.articleFavourite,isStandardProduct:true,addedAt:Date.now()};
  }else{ids(button).forEach(id=>delete favorites[id]);}
  try{localStorage.setItem('ear_config_favorites',JSON.stringify(favorites));}catch{return;}
  window.dispatchEvent(new CustomEvent('favorites-updated'));syncFavorites();
  if(adding){document.dispatchEvent(new Event('open-favorites-drawer'));if(typeof window.loadFavorites==='function')window.loadFavorites();}
 });
 window.addEventListener('favorites-updated',syncFavorites);
 window.addEventListener('storage',e=>{if(e.key==='ear_config_favorites'||e.key===null)syncFavorites();});
 syncFavorites();
})();
